<script lang="ts">
  import wallet, { connect, disconnect } from '../State/wallet.ts'
  import { handles, selectedHandle } from '../State/handle.ts'

  let clicked = false
  $: selectable = $handles.length > 0
  $: selecting = selectable && (!$selectedHandle || clicked)

  function select(handle: string) {
    if (!handle) {
      selectedHandle.update(() => "Anonymous")
    } else {
      selectedHandle.update(() => `$${handle}`)
    }
    clicked = false
  }
</script>

<label class="dropdown">
{#if $wallet.state == 'disconnected'}
<div class="button" on:click={connect}>
  Connect
</div>
{:else if $wallet.state == 'connecting' || $handles.length == 0}
<div class="button">
  Connecting...
</div>
{:else if $wallet.state == 'connected'}
<div class="button" class:selectable>
  {#if selecting}
    Choose a handle...
  {:else}
    {$selectedHandle}
  {/if}
</div>
{/if}

<input type="checkbox" class="cb-input" id="test" checked={selecting} on:input={() => clicked = !clicked} disabled={!selectable}>

<ul class="menu">
  {#each $handles as h}
  <li on:click|preventDefault={() => select(h)}>${h}</li>
  {/each}
  <li class="divider"></li>
  <li on:click|preventDefault={() => select()}>Anonymous</li>
  <li class="divider"></li>
  <li on:click|preventDefault={() => disconnect.update((x) => !x)}>Disconnect</li>

</ul>
</label>

<style>
  .dropdown {
    display: inline-block;
    position: relative;
    display: flex;
    flex-direction: row;
    justify-content: center;
  }
  .button {
    display: inline-block;
    border: 1px solid gray;
    border-radius: 4px;
    padding: 10px 30px 10px 20px;
    background-color: white;
    cursor: pointer;
    white-space: nowrap;
    width: 150px;
  }
  .button.selectable:after {
    content: '';
    position: absolute;
    top: 50%;
    right: 15px;
    transform: translateY(-50%);
    width: 0;
    height: 0;
    border-left: 5px solid transparent;
    border-right: 5px solid transparent;
    border-top: 5px solid black;
  }
  .button:hover {
    background-color: #eee;
  }
  .menu {
    position: absolute;
    top: 100%;
    border: 1px solid #ccc;
    border-radius: 4px;
    padding: 0;
    margin: 2px 0 0 0;
    box-shadow: 0 0 6px 0 rgba(0,0,0,0.1);
    background-color: white;
    list-style-type: none;
  }
  .cb-input {
    display: none;
  }
  .cb-input + .menu {
    display: none;
  }
  .cb-input:checked + .menu {
    display: block;
  }
  .menu li {
    width: 160px;
    padding: 10px 20px;
    cursor: pointer;
    white-space: nowrap;
  }
  .menu li:hover {
    background-color: #f6f6f6;
  }
  .menu li.divider {
    padding: 0;
    border-bottom: 1px solid #ccc;
  }
</style>